import { FC, Fragment, useState } from 'react'
import { Button } from './Button'
import { useTranslation } from 'react-i18next'
import { Box, useTheme, Dialog, Typography } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { IconButton } from 'packages/eid-ui'
import DomPurify from 'dompurify'
import ReactHtmlParser from 'react-html-parser'

const InstructionsModal: FC<any> = (props) => {
    const { open, onClose, title, header, children } = props

    return (
        <Dialog
            fullWidth
            scroll={'body'}
            open={open}
            onClose={onClose}
            aria-label={title || undefined}
        >
            <Box
                sx={{
                    backgroundColor: '#f7f8fa',
                    borderRadius: '8px',
                    wordBreak: 'break-all',
                    padding: 0,
                    '&:focus': {
                        outline: 'none',
                    },
                }}
            >
                {header ? (
                    header
                ) : (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            minHeight: '20px',
                            padding: '16px 8px',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                marginRight: '-16px',
                                marginTop: '-16px',
                                height: '10px',
                            }}
                        >
                            <IconButton onClick={onClose} size="large" >
                                <Icon name="Close" color="#959598" />
                            </IconButton>
                        </Box>
                        <Typography
                            sx={{
                                fontSize: '24px',
                                fontWeight: 'normal',
                                color: '#282828',
                            }}
                        >
                            {title}
                        </Typography>
                    </Box>
                )}

                {children}
            </Box>
        </Dialog>
    )
}

export type InstructionsProps = {
    title: string
    instructions: string
    button?: any
}
export const Instructions: FC<InstructionsProps> = (props) => {
    const { t } = useTranslation()

    const [showModal, setShowModal] = useState(false)

    const theme = useTheme()

    const header = (
        <Box
            sx={{
                padding: '32px 32px 16px 32px',
                width: '100%',
            }}
        >
            <Typography
                sx={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: theme?.palette?.common?.black,
                }}
            >
                {props.title}
            </Typography>
            <Box
                sx={{
                    position: 'absolute',
                    right: 20,
                    top: 16,
                    height: '10px',
                    cursor: 'pointer',
                }}
            >
                <IconButton onClick={() => setShowModal(false)} size="large" aria-label={t('Common_Close')} >
                    <Icon name="Close" color="#959598" />
                </IconButton>

            </Box>
        </Box>
    )

    const parsedHtml = ReactHtmlParser(DomPurify.sanitize(props.instructions))

    return (
        <Fragment>
            {props.button ? (
                props.button(setShowModal)
            ) : (
                <Button onClick={() => setShowModal(true)}>
                    {t('Common_MoreInfo')}
                </Button>
            )}
            <InstructionsModal open={showModal} title={props.title} header={header}>
                {parsedHtml && parsedHtml.length > 0 && (
                    <Box
                        sx={{
                            color: theme?.palette?.common?.black,
                            marginTop: '12px',
                            padding: '20px 20px 32px 32px',
                            backgroundColor: theme?.palette?.background?.paper,
                            overflow: 'scroll',
                            maxHeight: '500px',
                            wordBreak: 'break-word',
                        }}
                    >
                        {parsedHtml}
                    </Box>
                )}
            </InstructionsModal>
        </Fragment>
    )
}
